import type { BuyerBidDto, NegotiationRoundDto } from "../../../autogen/bff-api";

export const awardedStage = (
  winningBidIds: readonly string[],
  bids: readonly Pick<BuyerBidDto, "id" | "forNegotiationRound">[] | undefined,
  rounds: readonly NegotiationRoundDto[],
): NegotiationRoundDto | null | undefined => {
  if (winningBidIds.length === 0 || !bids) return undefined;
  const winners = bids.filter((bid) => winningBidIds.includes(bid.id));
  if (winners.length === 0) return undefined;
  const stages = winners.map((bid) => rounds.find((round) => round.id === bid.forNegotiationRound) ?? null);
  return stages.reduce<NegotiationRoundDto | null>(
    (latest, stage) => ((stage?.roundNumber ?? 0) > (latest?.roundNumber ?? 0) ? stage : latest),
    null,
  );
};
